import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 18a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-0"}],["path",{"d":"M5 6a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-1"}],["path",{"d":"M7 8v8","key":"svg-2"}],["path",{"d":"M9 18h6a2 2 0 0 0 2 -2v-5","key":"svg-3"}],["path",{"d":"M14 14l3 -3l3 3","key":"svg-4"}],["path",{"d":"M15 4l4 4","key":"svg-5"}],["path",{"d":"M15 8l4 -4","key":"svg-6"}]]

const IconGitBranchDeleted = createReactComponent('outline', 'git-branch-deleted', 'GitBranchDeleted', __iconNode);

export default IconGitBranchDeleted;